(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crampfit-product-seo"]) return;
  try {
    
  const selectCrampfitDefaultBlack = () => {
    if (!window.location.pathname.startsWith('/products/')) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (document.documentElement.dataset.crampfitDefaultColorApplied === 'true') return;

    const colorRadios = [...document.querySelectorAll('input[type="radio"]')].filter((input) =>
      input.name.toLowerCase().includes('color')
    );
    const blackOption = colorRadios.find((input) => input.value.trim().toLowerCase() === 'black');

    document.documentElement.dataset.crampfitDefaultColorApplied = 'true';

    if (blackOption && !blackOption.checked && !blackOption.disabled) {
      const blackVariantId = blackOption.dataset.variantId;

      if (blackVariantId) {
        const blackVariantUrl = new URL(window.location.href);
        blackVariantUrl.searchParams.set('variant', blackVariantId);
        window.location.replace(blackVariantUrl.toString());
        return;
      }

      blackOption.click();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectCrampfitDefaultBlack, { once: true });
  } else {
    requestAnimationFrame(selectCrampfitDefaultBlack);
  }

  document.addEventListener('shopify:section:load', selectCrampfitDefaultBlack);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
